var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5093 10L1.5463 9.99999C1.2026 9.99966 0.873084 9.86785 0.630056 9.63351C0.387027 9.39916 0.250343 9.08141 0.25 8.74999V1.25C0.250343 0.91858 0.387027 0.60083 0.630056 0.366482C0.873084 0.132133 1.2026 0.000330922 1.5463 0L14.5093 1.3113e-05C14.853 0.000344035 15.1825 0.132146 15.4255 0.366495C15.6685 0.600843 15.8052 0.918593 15.8056 1.25001V1.87501H16.4537C16.7974 1.87534 17.1269 2.00714 17.3699 2.24149C17.613 2.47584 17.7497 2.79359 17.75 3.12501V6.875C17.7495 7.20637 17.6127 7.52403 17.3698 7.75834C17.1268 7.99265 16.7973 8.12451 16.4537 8.125H15.8056V8.75C15.8051 9.08137 15.6683 9.39902 15.4253 9.63334C15.1823 9.86765 14.8529 9.9995 14.5093 10ZM1.5463 1.25V8.74999L14.5093 8.75V6.875H16.4537V3.12501H14.5093V1.25001L1.5463 1.25Z",
    fill: "#4BB725"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43537 2.5V7.49999H2.84277V2.5H5.43537Z",
    fill: "#4BB725"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32404 2.5V7.49999H6.73145V2.5H9.32404Z",
    fill: "#4BB725"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2127 2.5V7.49999H10.6201V2.5H13.2127Z",
    fill: "#4BB725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryHigh);
export default __webpack_public_path__ + "static/media/BatteryHigh.e749d5857f6e50716aa6d5555168c71b.svg";
export { ForwardRef as ReactComponent };